'use client';

import { useState, useMemo, ChangeEvent, MouseEvent, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { isCheckInteger } from '@/lib/BigNumbers';
import { compareObjects, compareArrays } from '@/lib/Compare';
import { readSmallWinSetting } from '@/api/bet/read';
import { ResReadSmallWinSettingType } from '@/types/bet/read-type';
import { updateSmallWinSetting } from '@/api/bet/update';
import { UpdateSmallWinSetting } from '@/types/bet/update-type';
import { createSmallWinSetting, deleteSmallWinSetting } from '@/api/bet/create';
import { CreateSmallWinSettingType } from '@/types/bet/create-type';

export default function SmallWinSettingForm({ gameSettingId }: { gameSettingId: string }) {
  // 초기 상태에서도 임시 ID를 생성하여 수정 가능하도록 함
  const getTempId = () => `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  const [rows, setRows] = useState<ResReadSmallWinSettingType[]>([
    {
      smallSetId: getTempId(),
      gameSettingId: gameSettingId,
      name: '',
      level: '',
      winToBetRatio: '',
      winProbability: '',
    },
  ]);
  // 서버에서 호출 한 뒤 값을 저장 (rows, oldRows)
  const [oldRows, setOldRows] = useState<ResReadSmallWinSettingType[]>([]);
  useEffect(() => {
    (async () => {
      console.log('11111111111111111');
      console.log(`readSmallWinSetting ${gameSettingId}`);
      const re = await readSmallWinSetting(gameSettingId);
      console.log(re);
      // 서버에서 받은 데이터는 그대로 사용 (smallSetId가 이미 있음)
      // 빈 배열이거나 데이터가 없을 때만 초기 행 추가
      if (re.data && re.data.length > 0) {
        setRows(re.data);
        setOldRows(re.data);
      } else {
        // 데이터가 없을 때만 초기 행 추가
        const initialRow = {
          smallSetId: getTempId(),
          gameSettingId: gameSettingId,
          name: '',
          level: '',
          winToBetRatio: '',
          winProbability: '',
        };
        setRows([initialRow]);
        setOldRows([initialRow]);
      }
    })();
  }, [gameSettingId]);
  // TODO 소액당첨 충당 비용
  const cost = '123 실제 서버 호출된 값 가져와야 함';

  const handleAddInputs = () => {
    // 새 행에는 임시 ID를 생성 (서버에 저장되기 전까지 사용)
    // temp- 접두사로 서버에서 생성된 ID와 구분
    const tempId = getTempId();
    setRows([
      ...rows,
      {
        smallSetId: tempId,
        gameSettingId: gameSettingId,
        name: '',
        level: '',
        winToBetRatio: '',
        winProbability: '',
      },
    ]);
  };

  const handleDelete = () => {
    if (rows.length > 1) {
      setRows((prevRows) => prevRows.slice(0, -1));
    } else {
      toast.error('최소 1개의 행이 필요합니다.');
    }
  };

  const handleInputChange = (rowId: string, field: keyof ResReadSmallWinSettingType, value: string) => {
    if (!rowId || rowId === '') {
      console.error('rowId가 없습니다:', rowId);
      return;
    }

    setRows((prevRows) => {
      // rowId로 특정 행 찾기
      const targetRow = prevRows.find((row) => row.smallSetId === rowId);
      if (!targetRow) {
        console.error('해당 rowId를 가진 행을 찾을 수 없습니다:', rowId, prevRows);
        return prevRows;
      }

      // 숫자 필드 검증
      if (field === 'level' || field === 'winToBetRatio' || field === 'winProbability') {
        if (value !== '' && !isCheckInteger(value)) {
          toast.error('소수점을 사용할 수 없습니다.');
          return prevRows;
        }
        // level, 당첨금 비율, 당첨확률은 마이너스 값 방지
        if ((field === 'level' || field === 'winToBetRatio' || field === 'winProbability') && value !== '') {
          const numValue = Number(value);
          if (numValue < 0) {
            toast.error('마이너스 값을 입력할 수 없습니다.');
            return prevRows;
          }
        }
        // 당첨금 비율 합계가 100을 넘지 않도록 검증
        // if (field === 'winToBetRatio' && value !== '') {
        //   const otherRowsTotal = prevRows
        //     .filter((row) => row.smallSetId !== rowId)
        //     .reduce((acc, row) => {
        //       const ratio = row.winToBetRatio ? Number(row.winToBetRatio) : 0;
        //       return acc + ratio;
        //     }, 0);
        //   const newValue = Number(value);
        //   const total = otherRowsTotal + newValue;
        //   if (total > 100) {
        //     toast.error('당첨금 비율 합계가 100%를 넘을 수 없습니다.');
        //     return prevRows;
        //   }
        // }
      }

      // 특정 행의 특정 필드만 업데이트 (엄격한 비교)
      return prevRows.map((row) => {
        if (row.smallSetId === rowId) {
          return { ...row, [field]: value };
        }
        return row;
      });
    });
  };

  // // 당첨금 비율 합계 계산
  // const totalWinToBetRatio = useMemo(() => {
  //   const sum = rows.reduce((acc, row) => {
  //     const ratio = row.winToBetRatio ? Number(row.winToBetRatio) : 0;
  //     return acc + ratio;
  //   }, 0);
  //   return sum;
  // }, [rows]);

  // // 비당첨 비율 계산 (100 - 당첨금 비율 합계)
  // const loseRatio = useMemo(() => {
  //   return 100 - totalWinToBetRatio;
  // }, [totalWinToBetRatio]);

  const handleUpdate = async (event: MouseEvent<HTMLButtonElement>) => {
    console.log('소액당첨 설정 업데이트(소액 당첨만 해당)');
    console.log('현재 rows:', rows);
    console.log('oldRows:', oldRows);

    try {
      // 1단계: DELETE - oldRows에는 있지만 rows에는 없는 행 삭제
      const deletedRows = oldRows.filter(
        (oldRow) => !oldRow.smallSetId.startsWith('temp-') && !rows.find((row) => row.smallSetId === oldRow.smallSetId),
      );
      console.log('DELETE 대상 행:', deletedRows);

      const deletePromises = deletedRows.map(async (row) => {
        console.log('행 삭제:', row.smallSetId);
        return await deleteSmallWinSetting(row.smallSetId);
      });

      // 2단계: CREATE - temp-로 시작하는 ID는 새로 생성
      const createRows = rows.filter((row) => row.smallSetId.startsWith('temp-'));
      console.log('CREATE 대상 행:', createRows);

      const createPromises = createRows.map(async (row) => {
        const createData: CreateSmallWinSettingType = {
          gameSettingId: row.gameSettingId,
          name: row.name,
          level: row.level,
          winToBetRatio: row.winToBetRatio,
          winProbability: row.winProbability,
        };
        console.log('새 행 생성:', createData);
        return await createSmallWinSetting(createData);
      });

      // 3단계: UPDATE - 기존 행의 변경사항 업데이트
      const updatePromises = rows
        .map((row, index) => {
          // temp-로 시작하는 행은 제외 (이미 create에서 처리)
          if (row.smallSetId.startsWith('temp-')) {
            return null;
          }

          const oldRow = oldRows.find((old) => old.smallSetId === row.smallSetId);
          if (!oldRow) {
            return null;
          }

          // 변경사항 확인
          const changes = compareObjects(row, oldRow);

          // 변경사항이 있으면 업데이트
          if (Object.keys(changes).length > 0) {
            const updateData: UpdateSmallWinSetting = {
              smallSetId: row.smallSetId,
              ...changes,
            };
            console.log('업데이트 데이터:', updateData);
            return updateSmallWinSetting(updateData);
          }

          return null;
        })
        .filter((promise) => promise !== null) as Promise<any>[];

      // DELETE, CREATE, UPDATE를 순차적으로 실행
      const deleteResults = await Promise.all(deletePromises);
      console.log('삭제 결과:', deleteResults);

      const createResults = await Promise.all(createPromises);
      console.log('생성 결과:', createResults);

      const updateResults = await Promise.all(updatePromises);
      console.log('업데이트 결과:', updateResults);

      toast.success('저장이 완료되었습니다.');

      // 저장 후 서버에서 최신 데이터 다시 가져오기
      const re = await readSmallWinSetting(gameSettingId);
      if (re.data && re.data.length > 0) {
        setRows(re.data);
        setOldRows(re.data);
      } else {
        // 데이터가 없을 때만 초기 행 추가
        const initialRow = {
          smallSetId: getTempId(),
          gameSettingId: gameSettingId,
          name: '',
          level: '',
          winToBetRatio: '',
          winProbability: '',
        };
        setRows([initialRow]);
        setOldRows([initialRow]);
      }
    } catch (error) {
      console.error('저장 실패:', error);
      toast.error('저장에 실패했습니다.');
    }
  };
  return (
    <Box p={2}>
      <Grid xs={12}>
        <Typography variant="h4">소액 당첨 설정</Typography>
      </Grid>
      <Grid container spacing={2} mb={2}>
        <Grid xs={3} sm={3}>
          <Typography variant="h6">이름</Typography>
        </Grid>
        <Grid xs={2} sm={2}>
          <Typography variant="h6">level</Typography>
        </Grid>
        <Grid xs={4} sm={4}>
          <Typography variant="h6">베팅액대비 당첨금 비율 (%)</Typography>
        </Grid>
        <Grid xs={3} sm={3}>
          <Typography variant="h6">참여자의 당첨확률 (%)</Typography>
        </Grid>
      </Grid>

      {rows.map((row: ResReadSmallWinSettingType, index: number) => {
        // 각 행은 이미 smallSetId를 가지고 있어야 함 (useEffect에서 처리)
        const rowId = row.smallSetId;
        if (!rowId) {
          console.error('행에 smallSetId가 없습니다:', row, index);
        }
        return (
          <Grid container spacing={2} key={rowId || `row-${index}`} mb={2}>
            <Grid xs={2} sm={2}>
              <FormControl fullWidth>
                <InputLabel>이름</InputLabel>
                <OutlinedInput
                  value={row.name}
                  label="이름"
                  name="name"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    handleInputChange(row.smallSetId, 'name', e.target.value);
                  }}
                />
              </FormControl>
            </Grid>

            <Grid xs={3} sm={3}>
              <FormControl fullWidth>
                <InputLabel>level</InputLabel>
                <OutlinedInput
                  value={row.level}
                  inputProps={{
                    type: 'number',
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    min: 0,
                  }}
                  placeholder="level"
                  label="level"
                  name="level"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    handleInputChange(row.smallSetId, 'level', e.target.value);
                  }}
                />
              </FormControl>
              <FormHelperText>※ 1부터 시작(수동설정), 같은 게임 내에서 고유값, 0이면 세팅 안함</FormHelperText>
            </Grid>

            <Grid xs={4} sm={4}>
              <FormControl fullWidth>
                <InputLabel>베팅액대비 당첨금 비율 (%)</InputLabel>
                <OutlinedInput
                  value={row.winToBetRatio}
                  inputProps={{
                    type: 'number',
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    min: 0,
                  }}
                  placeholder="베팅액대비 당첨금 비율"
                  label="베팅액대비 당첨금 비율 (%)"
                  name="winToBetRatio"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    handleInputChange(row.smallSetId, 'winToBetRatio', e.target.value);
                  }}
                />
              </FormControl>
            </Grid>

            <Grid xs={3} sm={3}>
              <FormControl fullWidth>
                <InputLabel>참여자의 당첨확률 (%)</InputLabel>
                <OutlinedInput
                  value={row.winProbability}
                  inputProps={{
                    type: 'number',
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    min: 0,
                  }}
                  placeholder="참여자의 당첨확률"
                  label="참여자의 당첨확률 (%)"
                  name="winProbability"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    handleInputChange(row.smallSetId, 'winProbability', e.target.value);
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
        );
      })}

      <Grid container spacing={2} mt={2}>
        <Grid xs={6}>
          <Button fullWidth variant="outlined" color="secondary" onClick={handleAddInputs}>
            추가
          </Button>
        </Grid>
        <Grid xs={6}>
          <Button fullWidth variant="outlined" color="secondary" onClick={handleDelete}>
            삭제
          </Button>
        </Grid>
        <Grid xs={12}>
          <Button fullWidth variant="contained" color="primary" onClick={handleUpdate}>
            소액당첨 설정 업데이트(소액 당첨만 해당)
          </Button>
        </Grid>
      </Grid>

      {/* <Box mt={3}>
        <Typography variant="h6">당첨금 비율 합계: {totalWinToBetRatio}%</Typography>
        <Typography variant="h6">비당첨 비율: {loseRatio}%</Typography>
      </Box> */}
    </Box>
  );
}
